import NiceModal from "@ebay/nice-modal-react";
import style from "./StoreSalesStatistics.module.css";
import { useNavigate } from "react-router-dom";

function StoreSalesStatistics({ totalSalesAmount, onViewDetail }) {
    // 숫자 포맷팅 함수
    const formatNumber = (num) => {
        return num ? num.toLocaleString() : '0';
    };
    return (
        <div className={style.tableContainer}>
            <table className={style.salesTable}>
                <thead>
                    <tr>
                        <th className={style.storeColumn}>매장명</th>
                        <th className={style.amountColumn}>매출정보</th>
                    </tr>
                </thead>
                <tbody>
                    {totalSalesAmount && totalSalesAmount.length > 0 ? (
                        totalSalesAmount.map((data, index) => (
                            <tr key={index}>
                                <td className={style.storeNameCell}>{data.storeName}</td>
                                <td className={style.amountInfoCell}>
                                    <div className={style.amountRow}>
                                        <span className={style.periodLabel}>월</span>
                                        <span className={`${style.amountValue} ${Number(data.monthlySales) > 0 ? style.hasAmount : ''}`}>
                                            {formatNumber(data.monthlySales)} 원
                                        </span>
                                    </div>
                                    <div className={style.amountRow}>
                                        <span className={style.periodLabel}>주</span>
                                        <span className={`${style.amountValue} ${Number(data.weeklySales) > 0 ? style.hasAmount : ''}`}>
                                            {formatNumber(data.weeklySales)} 원
                                        </span>
                                    </div>
                                    <div className={style.amountRow}>
                                        <span className={style.periodLabel}>일</span>
                                        <span className={`${style.amountValue} ${Number(data.dailySales) > 0 ? style.hasAmount : ''}`}>
                                            {formatNumber(data.dailySales)} 원
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" className={style.noData}>
                                데이터가 없습니다
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
export default StoreSalesStatistics;